import { Component } from '@angular/core';

@Component({
  selector: 'csl-about-us',
  templateUrl: './about-us.component.html'
})
export class AboutUsComponent {

}
